import React from 'react'

export function ClockIcon() {
  return (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M0.5 9C0.5 4.0374 4.5374 0 9.5 0C14.4626 0 18.5 4.0374 18.5 9C18.5 13.9626 14.4626 18 9.5 18C4.5374 18 0.5 13.9626 0.5 9ZM10.1458 8.7221H14.1905C14.5997 8.7221 14.9315 9.0539 14.9315 9.46314C14.9315 9.87239 14.5997 10.2042 14.1905 10.2042H9.40478C8.99554 10.2042 8.66374 9.87239 8.66374 9.46314V3.85899C8.66374 3.44974 8.99554 3.11794 9.40478 3.11794C9.81403 3.11794 10.1458 3.44974 10.1458 3.85899V8.7221Z" fill="#007BFF"/>
    </svg>
  )
}